import { ReactNode } from 'react';
import { Offcanvas } from 'react-bootstrap';

export interface OffcanvasWrapperProps {
  show: boolean;
  onHide: () => void;
  id: string;
  label: string;
  children: ReactNode;
  closeButton?: boolean;
}

export function OffcanvasWrapper({
  show,
  onHide,
  id,
  label,
  children,
  closeButton = true,
}: OffcanvasWrapperProps) {
  const labelId = `${id}Label`;

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement="end"
      id={id}
      aria-labelledby={labelId}
      className="pt-5"
      scroll
      backdrop={false}
    >
      <Offcanvas.Header closeButton={closeButton}>
        <Offcanvas.Title id={labelId}>
          {label}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {children}
      </Offcanvas.Body>
    </Offcanvas>
  );
}

